// @ts-expect-error moduleResolution:nodenext issue 54523
import { html } from 'lit';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { customElement } from 'lit/decorators.js';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { Task } from '@lit/task';
// @ts-expect-error moduleResolution:nodenext issue 54523
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import LightElement from './light-element.js';
import { IAccountManagerResponse } from '../models/IAccountManagerResponse.model.js';

@customElement('account-manager')
export default class AccountManager extends LightElement {

	private fallbackText = document.querySelector('.js-account-manager-fallback-text')?.innerHTML;

	private _accountManagerTask = new Task(this, {
		task: async ([], { signal }) => {
			const response = await fetch(`/api/tradeaccountmanager`, { signal });
			if (!response.ok) { throw new Error(response.status.toString()); }
			return response.json() as unknown as IAccountManagerResponse;
		},
		args: () => []
	});

	private renderLoading() {
		return html`
		<div class="c-account-manager__loader-container">
			<div class="c-loader c-loader--large">
		</div>
		</div>`;
	}

	private renderFallbackText() {
		if (this.fallbackText) {
			return html`<div class="c-cms c-cms--large">${unsafeHTML(this.fallbackText)}</div>`;
		}
		return html``;
	}

	private renderNonTrade() {
		return html``;
	}

	private renderTradeNoAccountManager() {
		return this.renderFallbackText();
	}

	private renderTradeAccountManager(response: IAccountManagerResponse) {
		return html`
		<div class="c-card__text-large">
			<p class="u-bold">Your account manager is</p>
			<div class="u-mb5">
				${response.accountManager.displayName}
			</div>
			${response.accountManager.mobileNumber ? html`
				<div class="c-icon__text-container u-mb5">
					<img src="/images/icons/svgs/mobile.svg?v=20708" class="c-icon c-icon--by-medium-text noPrint" width="20" height="20" loading="lazy" alt="" />
					<span class="c-icon__text"><a href="tel:${response.accountManager.mobileNumber}" class="u-link-alt">${response.accountManager.mobileNumber}</a></span>
				</div>` :
			""}
			${response.accountManager.hasWorkNumber ? html`
				<div class="c-icon__text-container u-mb5">
					<img src="/images/icons/svgs/phone.svg?v=20708" class="c-icon c-icon--by-medium-text noPrint" width="20" height="20" loading="lazy" alt="" />
					<span class="c-icon__text"><a href="tel:${response.accountManager.workNumber}" class="u-link-alt">${response.accountManager.workNumber}</a></span>
				</div>` :
			""}
			${response.accountManager.hasEmail ? html`
				<div class="c-icon__text-container u-mb5">
					<img src="/images/icons/svgs/email.svg?v=20708" class="c-icon c-icon--by-medium-text noPrint" width="20" height="20" loading="lazy" alt="" />
					<span class="c-icon__text"><a href="mailto:${response.accountManager.email}" class="u-link-alt">${response.accountManager.email}</a></span>
				</div>
				` :
			""}
			${response.accountManager.hasLastUpdated ? html`
				<span>Last updated: ${response.accountManager.lastUpdated}</span>` :
			""}
		</div>`;
	}

	render() {
		return this._accountManagerTask.render({
			pending: () => this.renderLoading(),
			complete: (response) => {
				if (response.isTrade) {
					if (response.accountManager.isValid) {
						return this.renderTradeAccountManager(response);
					} else {
						return this.renderTradeNoAccountManager();
					}
				} else {
					return this.renderNonTrade();
				}
			},
			error: () => this.renderFallbackText()
		});
	}

}
